import React, {Component} from 'react';
import Footer from './Footer';

/** Renders the App */
export default class App extends Component {
  /**
   * Renders the App component.
   * @returns {string} JSX representation of the component.
   */
  render() {
    return (
      <div className="container">
        <main className="row">{this.props.children}</main>
        <Footer className="row" />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/App.js